//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layout2d.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[],[[["journal_identifier"],"FindObject",{R_:{found:"Layout2d.Component"}},1,0],[["component"],"CreateDefineComponentBuilder",{R_:{builder:"Layout2d.DefineComponentBuilder"}},1,0],[[],"CreateInsertComponentBuilder",{R_:{builder:"Layout2d.InsertComponentBuilder"}},0,0],[[],"CreateReplaceComponentBuilder",{R_:{builder:"Layout2d.ReplaceComponentBuilder"}},0,0],[[],"CreateSmashComponentBuilder",{R_:{builder:"Layout2d.SmashComponentBuilder"}},0,0],[[],"CreateMakeComponentUniqueBuilder",{R_:{builder:"Layout2d.MakeComponentUniqueBuilder"}},0,0],[[],"CreateDefineComponentAnchorPointBuilder",{R_:{builder:"Layout2d.DefineComponentAnchorPointBuilder"}},0,0],[[],"CreatePublishComponentBuilder",{R_:{builder:"Layout2d.PublishComponentBuilder"}},0,0],[[],"CreateNewComponentBuilder",{R_:{builder:"Layout2d.NewComponentBuilder"}},0,0],[["components"],"DeleteComponents",{},1,0],[["disObject"],"IsComponentMember",{R_:{isMember:''}},1,0],[[],"CreateAssemblyFromLayout2dBuilder",{R_:{builder:"Layout2d.AssemblyFromLayout2dBuilder"}},0,0],[[],"CreateReparentComponentBuilder",{R_:{builder:"Layout2d.ReparentComponentBuilder"}},0,0],[["components"],"UpdateComponents",{},1,0],[["components"],"UpdateComponentHierarchy",{},1,0],[["myView"],"CreateComponentFrom3dBuilder",{R_:{builder:"Layout2d.CreateComponentFrom3DBuilder"}},1,0],[[],"CreateExportComponentHierarchyBuilder",{R_:{builder:"Layout2d.ExportComponentHierarchyBuilder"}},0,0],[[],"CreateAssociativeAssemblyBuilder",{R_:{builder:"Layout2d.AssociativeAssemblyBuilder"}},0,0],[[],"CreateInheritDisplayAttributesBuilder",{R_:{builder:"Layout2d.InheritDisplayAttributesBuilder"}},0,0],[[],"CreateComponentActiveSetBuilder",{R_:{builder:"Layout2d.ComponentActiveSetBuilder"}},0,0]],[["OrderManagers","Drawings.OrderManager",0]]];
SPLM.Layout2d.ComponentCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Layout2d.ComponentCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;